export const en = {
    "k_ff4b4ab7": "Data source middleware cannot be registered twice",
    "k_478a61cc": "Recent visit to",
    "k_e25c7e09": "You can be authorized to&nbsp;",
    "k_564d749": "&nbsp;Database registered in",
    "k_2a8febb0": "Target database",
    "k_9a89269b": "Please select a database",
    "k_94097c82": "Please select a database and enter appId or name to search",
    "k_8ccbaca0": "You do not have administrator privileges for this database. Please ask the administrator to authorize it.",
    "k_72519556": "Please enter the name of the database you want to access",
    "k_b7210974": "Please enter database user name",
    "k_b8533e64": "Please enter the password for the database",
    "k_8af1e732": "Please enter the IP address of the database",
    "k_3dd6bb58": "Please enter the port number of the database",
    "k_f54b49d5": "Please enter the database domain name or Polaris address",
    "k_edd154f6": "Database type",
    "k_ca7692fe": "Project ID",
    "k_64ccc568": "Please enter the project ID, which is used as a unique identification within the platform. Only letters, numbers and underscores can be used",
    "k_926fe781": "Please enter the project name. It is recommended to enter a readable Chinese name",
    "k_1d579f54": "Item description",
    "k_497f83d8": "Please enter the project description and suggest describing the data content, data source and purpose, etc.",
    "k_2f0bc3df": "Corresponding to \"character_set_client\",\"character_set_connection\", \"character_set_results\" settings",
    "k_4afd87ec": "The default value is utf8mb4",
    "k_98e22235": "Character sorting method",
    "k_96176d9a": "The default value is `UTF8MB4_GENERAL_CI`. Note that all letters in the character set must be capitalized.",
    "k_e5b3fd1a": "Big numbers",
    "k_1523b180": "If the type `BIGINT` is involved in the mount table, this attribute needs to be turned on",
    "k_4015ed1e": "Database",
    "k_12ff6a94": "Please enter the name of the target database",
    "k_1c368fac": "User name",
    "k_61c6b8de": "Database user name",
    "k_c562bad2": "Database password",
    "k_18d38ed6": "Database IP",
    "k_cbaec4b2": "Database port number",
    "k_e01d055d": "Host of the database",
    "k_bde7a28d": "Connection mode",
    "k_4c04f9f1": "Domain name or North Star",
    "k_f546a076": "The database needs to authorize necessary data operation permissions. Please refer to the detailed document.",
    "k_1d45f3a7": "Mount your own database »",
    "k_e193810a": "Test Connection",
    "k_21070af0": "Test is successful",
    "k_b938c554": "Test failed: {arg_0}",
    "k_4e3e203e": "New database",
    "k_2aae0550": "Create a database",
    "k_e6d18ee6": "Mount external database",
    "k_ff82f6c6": "Project database:",
    "k_d61588eb": "Add database",
    "k_91f0449f": "Failed to load project database:",
    "k_d46cd6c2": "Failed to load project database {arg_0}",
    "k_f04b11b9": "Add database successfully"
};
